import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';

import { FormFieldDirective } from './FormField.directive';

@NgModule({
  declarations: [FormFieldDirective],
  exports: [FormFieldDirective],
  imports: [MatFormFieldModule, FormsModule],
})
export class MgFormFieldModule {}
